import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useUsersList(data = {}) {
  const { enabled = false, queryParams = '', configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getUsersList() {
    return privateFetch.get(`/v1/admin/user${queryParams}`, configs).then((res) => res.data);
  }

  return useQuery(['users-lists', { data }], getUsersList, { enabled, keepPreviousData: true });
}

export default useUsersList;
